import Product from "../../../../../../@types/Product";

const Tops: Product[] = [
    {
        id: 1,
        name: '94″ Top - Black',
        sku: '26-213',
        price: 0.00,
        retailPrice: 0.00,
    },
];

export default Tops;